/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Return_To_SortingInputs */

const vi_warehouse_defects_return_to_sorting = /** @type {(inputs: Warehouse_Defects_Return_To_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả về kho phân loại`)
};

/**

* @param {Warehouse_Defects_Return_To_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_return_to_sorting = /** @type {((inputs?: Warehouse_Defects_Return_To_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Return_To_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_return_to_sorting(inputs)
});